// ============================================================
// TMR Portal Admin — as colunas da planilha de Usuários
// ============================================================
import { displayPhone } from '../../lib/phone';
import type { UserListItem } from '../../data/users/contract';
import type { ExportColumn } from '../../lib/export/types';

/**
 * The operator directory as a spreadsheet (20 §9).
 *
 * The three booleans go out as "Sim"/"Não" rather than TRUE/FALSE: this file is read by people, and the
 * screen says Sim. `activeRoleCount` is a real number so it can be filtered and summed in Excel — zero
 * grants is the row somebody exports this list to find.
 */
export const USER_EXPORT_COLUMNS: ExportColumn<UserListItem>[] = [
  { header: 'Nome', value: (u) => u.name },
  { header: 'E-mail', value: (u) => u.email },
  { header: 'Telefone', value: (u) => (u.phone ? displayPhone(u.phone) : '') },
  { header: 'Situação', value: (u) => (u.disabled ? 'Inativo' : 'Ativo') },
  { header: 'Convite aceito', value: (u) => u.hasClerkAccount },
  { header: 'Papéis ativos', value: (u) => u.activeRoleCount },
  { header: 'Login local', value: (u) => u.localFallbackEnabled },
  { header: 'Usuário no legado', value: (u) => u.legacyUserId },
  { header: 'Cadastrado em', value: (u) => new Date(u.createdAt) },
];
